import _ from "lodash";

export class SearchArguments {
    constructor(conditions) {
        this.setConditions(conditions);
        this.order = [];
        this.pagination = {};
    }

    setConditions(conditions) {
        this.conditions = conditions;

        return this;
    }

    setPagination(max, page) {
        this.pagination = {
            max: max,
            page: page,
        };

        return this;
    }

    addOrder(column, direction) {
        if (typeof column === "string") {
            this.order.push([column, direction || 'asc']);
        } else if (Array.isArray(column)) {
            if (Array.isArray(column[0]))
                this.order.push(...column);
            else
                this.order.push(column);
        } else if (typeof column === "object") {
            this.order.push([
                _.get(column, 'field'),
                _.get(column, 'direction', 'asc')
            ]);
        }

        return this;
    }
}

export class ObjectWithoutIdException{
    constructor(object, fields, message){
        this.object = object;
        this.fields = fields;
        this.message = message || 'object without id';
    }
}

const emptyValues = ['', false, null, undefined];
const defaultIdFields = ['uuid', '_id', 'id', 'code', 'abbr'];
const idTypes = ["string", "number"];

export const GetIdFromObject = function(object, fields){
    if(idTypes.inArray(typeof  object)) {
        return object;
    }

    fields = fields || defaultIdFields;
    const field = fields.firstOf(field => _.get(object, field));
    if(!field){
        throw new ObjectWithoutIdException(object, field);
    }

    const value = _.get(object, field);
    if(emptyValues.inArray(value)){
        throw new ObjectWithoutIdException(object, field);
    }

    return value;
}
